import React from 'react';
import './IntroSection.css';

const IntroSection = () => {
  return (
    <section className="intro-section">
      <div className="intro-grid">
        <div className="intro-accent">
          <div className="intro-accent-text">R6</div>
        </div>
        <div className="intro-content-wrapper">
          <div>
            <h2 className="intro-heading">
              Growing organizations need comprehensive talent solutions—from foundational to strategic.
            </h2>
            <p className="intro-text">
              Whether you're a small business scaling operations, a midsized enterprise optimizing talent, a franchise managing multiple locations, a civic organization driving community impact, or a nonprofit advancing your mission—The R6™ Collective delivers complete talent solutions through The Right 6™ Framework. We provide both foundational and enterprise-level capabilities to organizations ready to build agile and strategic talent solutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;